import Resource from './Resource';

type SaveOptions = {
	skipNotification?: boolean;
	skipErrorNotification?: boolean;
	updateSuccessBody?: string;
};

class UserParam extends Resource {
	constructor() {
		super('master/userParam');

		this.notifications = {
			save: (_data: unknown, opts: SaveOptions = {}) => ({
				title: 'default.updated',
				body: opts.updateSuccessBody ?? 'updated.userParam',
				style: 'success',
				icon: 'check',
				type: 'body'
			}),
			saveError: () => ({
				title: 'default.error',
				body: 'saveError.userParam',
				style: 'error',
				icon: 'times',
				type: 'body'
			})
		} as any;
	}

	save(paramId: number, value: unknown, options: SaveOptions = {}) {
		if (value === undefined || !paramId) {
			return Promise.reject('No params');
		}

		return this._putRequest(String(paramId), { value }, { methodName: 'save', ...options });
	}
}

export default new UserParam();
